import { styled } from "styled-components";
import NotchedButton from "../Common/SkipButton";

const Background = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  background-color: black;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 1;
  z-index: 999;

  animation: fadeOut 2s ease-in;
  animation-delay: ${(props) => props.delay}s;
  animation-fill-mode: forwards;
  @keyframes fadeOut {
    0% {
      background-color: black;
    }
    100% {
      background-color: #eeeeea;
    }
    /* 75% {
      color: white;
    }
    100% {
      color: black;
    } */
  }
`;

const TextIntro = styled.div`
  font-size: 50px;
  font-family: "Amatic SC", cursive;
  animation: fadeInOut 2.5s ease-in;
  animation-delay: ${(props) => props.delay}s;
  animation-fill-mode: forwards;

  @keyframes fadeInOut {
    0% {
      color: black;
    }
    100% {
      color: white;
    }
    /* 75% {
      color: white;
    }
    100% {
      color: black;
    } */
  }
`;



function IntroFade({ setAnimate }) {
  return (
    <div>
      <Background delay={7.5}>
        <NotchedButton text="Skip" setAnimate={setAnimate}/>
        {/* <TextIntro delay={0}> Hello World </TextIntro> */}
        <TextIntro delay={0}> My name is Ash </TextIntro>
        <TextIntro delay={2.5}> This is my site </TextIntro>
        <TextIntro delay={5}> Come on in </TextIntro>
      </Background>
    </div>
  );
}

export default IntroFade;
